
import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: 'Michael Johnson',
      role: 'Homeowner',
      content: 'LineFlow did an outstanding job on our new home plumbing installation. Professional, efficient, and the quality of work exceeded our expectations. Highly recommend!',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/fed48eafc49763c4d72c466d7d306618.jpg'
    },
    {
      name: 'Sarah Williams',
      role: 'Property Developer',
      content: 'We\'ve worked with LineFlow on multiple residential projects. Their expertise in underground piping and civil engineering is unmatched. Always on time and within budget.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20female%20property%20developer%20in%20business%20attire%20smiling%20warmly%20clean%20simple%20background%20natural%20lighting%20emphasizing%20professionalism%20and%20success&width=200&height=200&seq=testimonial-client-002&orientation=squarish'
    },
    {
      name: 'David Chen',
      role: 'General Contractor',
      content: 'LineFlow Underground & Civil is our go-to partner for all plumbing needs. Their team is knowledgeable, reliable, and delivers exceptional results every time.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20experienced%20male%20general%20contractor%20wearing%20work%20shirt%20smiling%20confidently%20clean%20simple%20background%20natural%20lighting%20emphasizing%20expertise%20and%20reliability&width=200&height=200&seq=testimonial-client-003&orientation=squarish'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-[#FF6B35]/10 rounded-full mb-4">
            <span className="text-[#FF6B35] font-bold text-sm tracking-wide">TESTIMONIALS</span>
          </div>
          <h3 className="text-5xl lg:text-6xl font-black text-[#0F4C81] mb-6">
            What Our Clients Say
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it - hear from our satisfied clients
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative max-w-4xl mx-auto">
          {/* Main Testimonial */}
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-12 shadow-xl">
            <div className="flex flex-col items-center text-center">
              {/* Image */}
              <div className="w-24 h-24 mb-6">
                <img
                  src={testimonials[activeIndex].image}
                  alt={testimonials[activeIndex].name}
                  className="w-full h-full object-cover object-top rounded-full ring-4 ring-[#FF6B35]/20"
                />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-2xl text-[#FF6B35]"></i>
                ))}
              </div>

              {/* Content */}
              <p className="text-xl text-gray-700 mb-8 leading-relaxed italic">
                "{testimonials[activeIndex].content}"
              </p>

              {/* Author */}
              <div>
                <div className="text-xl font-bold text-[#0F4C81] mb-1">
                  {testimonials[activeIndex].name}
                </div>
                <div className="text-gray-600 font-medium">
                  {testimonials[activeIndex].role}
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Dots */}
          <div className="flex justify-center gap-3 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === activeIndex
                    ? 'bg-[#FF6B35] w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              ></button>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={() => setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1))}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-16 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-[#FF6B35] hover:text-white transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>
          <button
            onClick={() => setActiveIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1))}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-16 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-[#FF6B35] hover:text-white transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
